import { change } from 'redux-form';
import moment from 'moment';
import _ from 'lodash';

import {
  ItemMaintenanceEnum,
  BidPriceEnum,
  UpdateBidPriceDetailsEnum,
  FilterEnum,
  TabItemMaintenanceEnum,
  TransactionDetailsEnum,
  FifoEnum,
} from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { ITEM_MAINTENANCE_BID_PRICE_FORM_NAME } from 'Common/FormEnum';
import { DropDownEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { BracketTypeEnum } from 'Common/Constants/Enumeration/ItemMaintenanceEnum';
import { KitchenItemPrepareInHouseFilterEnum } from 'Common/GridHelper';

export const basicURL = '/itemmaintenance';

export const makeOptionsDataWithEmpty = data => {
  if (data && Array.isArray(data) && data.length) {
    let containZero = _.find(data, ['Id', 0]);
    !containZero &&
      data.splice(0, 0, {
        Description: '',
        Id: 0,
      });
    data = data.map(item => {
      let text = item.Description;
      if (!item.Id) {
        text = '';
      }
      return {
        value: item.Id,
        key: item.Id,
        text,
      };
    });
  }

  return data;
};
export const addPropertiesForSave = (values, itemDetail, id) => {
  let VALUES = { ...itemDetail };
  VALUES[ItemMaintenanceEnum.Id] = +id;
  VALUES[ItemMaintenanceEnum.Description] =
    values[ItemMaintenanceEnum.Description];
  VALUES[ItemMaintenanceEnum.ItemCode] =
    itemDetail[ItemMaintenanceEnum.ItemCode];
  VALUES[ItemMaintenanceEnum.MFRProductCode] =
    values[ItemMaintenanceEnum.MFRProductCode];
  VALUES[ItemMaintenanceEnum.MFRName] = values[ItemMaintenanceEnum.MFRName];
  VALUES[ItemMaintenanceEnum.MFRUrl] = values[ItemMaintenanceEnum.MFRUrl];
  VALUES[FilterEnum.AlternateItemId] = values[FilterEnum.AlternateItemId];
  VALUES[FilterEnum.GroupId_Cat] = values[FilterEnum.GroupId_Cat];
  VALUES[FilterEnum.GroupId_Bid] = values[FilterEnum.GroupId_Bid];
  VALUES[FilterEnum.GroupId_Item] = values[FilterEnum.GroupId_Item];
  VALUES[FilterEnum.TaxGroupId] = values[FilterEnum.TaxGroupId];
  VALUES[ItemMaintenanceEnum.AllowPartialOrdering] =
    values[ItemMaintenanceEnum.AllowPartialOrdering];
  VALUES[ItemMaintenanceEnum.ActiveStatus] = values[
    ItemMaintenanceEnum.ActiveStatus
  ]
    ? ActiveStatusEnum.Active
    : ActiveStatusEnum.Inactive;
  VALUES[ItemMaintenanceEnum.PrepareInHouse] =
    values[ItemMaintenanceEnum.PrepareInHouse] ===
    KitchenItemPrepareInHouseFilterEnum.Yes;
  delete VALUES[ItemMaintenanceEnum.StorageLocationIds];
  delete VALUES[BidPriceEnum.GTINNumber];
  return VALUES;
};

export const ActiveStatusEnum = {
  Active: 'A',
  Inactive: 'I',
};

export const makeNewBidItem = (
  BidPriceDetails,
  BidId,
  IdKey,
  lookupForGTINNumberAndVendor
) => {
  const index = _.findIndex(BidPriceDetails, item => {
    return item.BidId === BidId;
  });
  let newBidItem = _.cloneDeep(BidPriceDetails[index]);
  if (newBidItem) {
    newBidItem.PrimaryPrice = '0.0000';
    newBidItem.BidId = 0;
    newBidItem[BidPriceEnum.GTINNumber] =
      lookupForGTINNumberAndVendor[newBidItem[BidPriceEnum.VendorId]];
    newBidItem.IdKey = IdKey;
    newBidItem[BidPriceEnum.BeginDT] = moment(
      BidPriceDetails[index][UpdateBidPriceDetailsEnum.BidPriceEndDate]
    ).add(1, 'days');
    newBidItem[UpdateBidPriceDetailsEnum.BidPriceEndDate] = moment(
      BidPriceDetails[index][UpdateBidPriceDetailsEnum.BidPriceEndDate]
    ).add(30, 'days');
    newBidItem.isNewAdded = true;
    newBidItem.modified = true;
  }
  return newBidItem;
};

export const validateItemDetailFormData = values => {
  const errors = {};

  if (
    !values[ItemMaintenanceEnum.ItemCode] ||
    !_.trim(values[ItemMaintenanceEnum.ItemCode]).length
  ) {
    errors[ItemMaintenanceEnum.ItemCode] = 'Item Code is required.';
  }

  if (
    !values[ItemMaintenanceEnum.Description] ||
    !_.trim(values[ItemMaintenanceEnum.Description]).length
  ) {
    errors[ItemMaintenanceEnum.Description] = 'Item Description is required.';
  }
  if (!values[FilterEnum.GroupId_Cat] || !values[FilterEnum.GroupId_Cat]) {
    errors[FilterEnum.GroupId_Cat] = 'Account Category is required.';
  }

  return errors;
};

export const validateItemBidPriceFormData = values => {
  const errors = {};

  if (
    !values[BidPriceEnum.QtyPerUnit] ||
    !_.trim(values[BidPriceEnum.QtyPerUnit]).length
  ) {
    errors[BidPriceEnum.QtyPerUnit] =
      'Pack Size is required!  Please Enter a Pack Size.';
  } else if (values[BidPriceEnum.QtyPerUnit] <= 0) {
    errors[BidPriceEnum.QtyPerUnit] =
      'Pack Size must be greater than zero!  Please Enter a valid Pack Size greater than zero.';
  }

  if (!values[BidPriceEnum.Unit] || !_.trim(values[BidPriceEnum.Unit]).length) {
    errors[BidPriceEnum.Unit] = 'Unit is required!  Please Enter Unit.';
  }

  if (
    !values[BidPriceEnum.SecondaryUnit] ||
    !_.trim(values[BidPriceEnum.SecondaryUnit]).length
  ) {
    errors[BidPriceEnum.SecondaryUnit] =
      'Pack Unit is required!  Please Enter Pack Unit.';
  }

  if (
    !values[BidPriceEnum.VendorId] ||
    !_.trim(values[BidPriceEnum.VendorId]).length
  ) {
    errors[BidPriceEnum.VendorId] =
      'Distributor is required!  Please Enter Distributor.';
  }

  if (
    +values[BidPriceEnum.SecondaryUnitWeight] &&
    (!values[BidPriceEnum.SecondaryUnitMeasure] ||
      !_.trim(values[BidPriceEnum.SecondaryUnitMeasure]).length)
  ) {
    errors[BidPriceEnum.SecondaryUnitMeasure] =
      'Measure is required!  Please Enter Measure .';
  }

  if (
    values[UpdateBidPriceDetailsEnum.BracketType] === BracketTypeEnum.Weight
  ) {
    if (
      !values[BidPriceEnum.SecondaryUnitWeight] ||
      (values[BidPriceEnum.SecondaryUnitWeight] &&
        +values[BidPriceEnum.SecondaryUnitWeight] === 0)
    ) {
      errors[BidPriceEnum.SecondaryUnitWeight] = 'Pack Weight is required.';
    }
  }
  return errors;
};

export const convertDates = data => {
  data.forEach(item => {
    item[BidPriceEnum.BeginDT] = moment(item[BidPriceEnum.BeginDT]).format(
      DATE_FORMAT_FOR_UI
    );
    item[UpdateBidPriceDetailsEnum.BidPriceEndDate] = moment(
      item[UpdateBidPriceDetailsEnum.BidPriceEndDate]
    ).format(DATE_FORMAT_FOR_UI);
  });
  return data;
};

export const makeBidPricePayload = (ItemId, data, DeletedBidIds) => {
  return {
    ItemId,
    BidPriceDetails: convertDates(data),
    DeletedBidIds: _.uniq(DeletedBidIds),
  };
};

export const updateGridField = (dispatch, original) => {
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      UpdateBidPriceDetailsEnum.BidId,
      original[UpdateBidPriceDetailsEnum.BidId]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.BeginDT,
      moment(original[BidPriceEnum.BeginDT]).format(DATE_FORMAT_FOR_UI)
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      UpdateBidPriceDetailsEnum.BidPriceEndDate,
      moment(original[UpdateBidPriceDetailsEnum.BidPriceEndDate]).format(
        DATE_FORMAT_FOR_UI
      )
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.Unit,
      original[BidPriceEnum.Unit]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.SecondaryUnit,
      original[BidPriceEnum.SecondaryUnit]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.VendorId,
      original[BidPriceEnum.VendorId]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.VendorItem,
      original[BidPriceEnum.VendorItem]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.ContractItem,
      original[BidPriceEnum.ContractItem]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.CurrentBrand,
      original[BidPriceEnum.CurrentBrand]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.UPC,
      original[BidPriceEnum.UPC]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.CostPerServing,
      calculateCostPerServing(
        original[BidPriceEnum.PrimaryPrice],
        original[BidPriceEnum.ServingsPerUnit]
      )
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.SecondaryUnitWeight,
      original[BidPriceEnum.SecondaryUnitWeight]
        ? original[BidPriceEnum.SecondaryUnitWeight]
        : '0.00'
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.SecondaryUnitMeasure,
      original[BidPriceEnum.SecondaryUnitMeasure]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.PrimaryPrice,
      original[BidPriceEnum.PrimaryPrice]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.QtyPerUnit,
      original[BidPriceEnum.QtyPerUnit]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.ServingsPerUnit,
      original[BidPriceEnum.ServingsPerUnit]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      BidPriceEnum.GTINNumber,
      original[BidPriceEnum.GTINNumber]
    )
  );
  dispatch(
    change(
      ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
      UpdateBidPriceDetailsEnum.BracketType,
      original[UpdateBidPriceDetailsEnum.BracketType]
    )
  );
  updateBracketPricing(
    dispatch,
    original[UpdateBidPriceDetailsEnum.BracketPricingDetails]
  );
};

export const INITIAL_VALUES = {
  [UpdateBidPriceDetailsEnum.BidId]: '',
  [BidPriceEnum.PrimaryPrice]: '',
  [BidPriceEnum.BeginDT]: '',
  [UpdateBidPriceDetailsEnum.BidPriceEndDate]: '',
  [BidPriceEnum.Unit]: '',
  [BidPriceEnum.QtyPerUnit]: '',
  [BidPriceEnum.SecondaryUnit]: '',
  [BidPriceEnum.VendorId]: '',
  [BidPriceEnum.VendorItem]: '',
  [BidPriceEnum.ContractItem]: '',
  [BidPriceEnum.CurrentBrand]: '',
  [BidPriceEnum.UPC]: '',
  [BidPriceEnum.ServingsPerUnit]: '',
  [BidPriceEnum.CostPerServing]: '',
  [BidPriceEnum.SecondaryUnitWeight]: '',
  [BidPriceEnum.SecondaryUnitMeasure]: '',
  [ItemMaintenanceEnum.ItemCode]: '',
  [ItemMaintenanceEnum.Description]: '',
  [FilterEnum.AlternateItemId]: 0,
  [FilterEnum.GroupId_Cat]: 0,
  [FilterEnum.GroupId_Bid]: 0,
  [FilterEnum.GroupId_Item]: 0,
  [FilterEnum.TaxGroupId]: 0,
  [ItemMaintenanceEnum.AllowPartialOrdering]: false,
  [ItemMaintenanceEnum.ActiveStatus]: true,
  [ItemMaintenanceEnum.MFRProductCode]: '',
  [ItemMaintenanceEnum.MFRName]: '',
  [ItemMaintenanceEnum.MFRUrl]: '',
};

export const calculateCostPerServing = (primaryPrice, servingsPerUnit) => {
  let calculateCostPerServing = '0.00';
  if (+servingsPerUnit) {
    if (+primaryPrice) {
      calculateCostPerServing = '' + +primaryPrice / +servingsPerUnit;
    }
  }
  return (+calculateCostPerServing).toFixed(4);
};

export const bidDatesMaxValidation = BidPriceDetails => {
  return BidPriceDetails.some(item => {
    return moment(item[BidPriceEnum.BeginDT]).isAfter(
      item[UpdateBidPriceDetailsEnum.BidPriceEndDate],
      'day'
    );
  });
};

export const bidDatesValidation = BidPriceDetails => {
  let IdKey = 0;
  let foundDateConflict = false;
  BidPriceDetails = BidPriceDetails.map(item => {
    item.IdKey = IdKey++;
    return item;
  });
  const BidPriceDetailsCopy = _.cloneDeep(BidPriceDetails);
  foundDateConflict = BidPriceDetailsCopy.some(itemCopy => {
    return BidPriceDetails.some(item => {
      if (
        itemCopy.IdKey !== item.IdKey &&
        (moment(itemCopy[BidPriceEnum.BeginDT]).isBetween(
          item[BidPriceEnum.BeginDT],
          item[UpdateBidPriceDetailsEnum.BidPriceEndDate]
        ) ||
          moment(itemCopy[BidPriceEnum.BeginDT]).isSame(
            item[BidPriceEnum.BeginDT]
          ) ||
          moment(itemCopy[BidPriceEnum.BeginDT]).isSame(
            item[UpdateBidPriceDetailsEnum.BidPriceEndDate]
          ))
      ) {
        foundDateConflict = true;
      }
      return foundDateConflict;
    });
  });
  return foundDateConflict;
};

export const getInitialValues = (bidPriceDetailsData, itemDetails) => {
  let initialValues = INITIAL_VALUES;
  if (bidPriceDetailsData && itemDetails && itemDetails.length) {
    initialValues = {
      [BidPriceEnum.BidItemDesc]:
        itemDetails[0][ItemMaintenanceEnum.ItemCode] +
        ' - ' +
        itemDetails[0][ItemMaintenanceEnum.Description],
      [ItemMaintenanceEnum.ItemCode]:
        itemDetails[0][ItemMaintenanceEnum.ItemCode],
      [ItemMaintenanceEnum.Description]:
        itemDetails[0][ItemMaintenanceEnum.Description],
      [FilterEnum.AlternateItemId]: itemDetails[0][FilterEnum.AlternateItemId],
      [FilterEnum.GroupId_Cat]: itemDetails[0][FilterEnum.GroupId_Cat],
      [FilterEnum.GroupId_Bid]: itemDetails[0][FilterEnum.GroupId_Bid],
      [FilterEnum.GroupId_Item]: itemDetails[0][FilterEnum.GroupId_Item],
      [FilterEnum.TaxGroupId]: itemDetails[0][FilterEnum.TaxGroupId],
      [ItemMaintenanceEnum.AllowPartialOrdering]:
        itemDetails[0][ItemMaintenanceEnum.AllowPartialOrdering],
      [ItemMaintenanceEnum.ActiveStatus]:
        itemDetails[0][ItemMaintenanceEnum.ActiveStatus] ===
        ActiveStatusEnum.Active,
      [ItemMaintenanceEnum.MFRProductCode]:
        itemDetails[0][ItemMaintenanceEnum.MFRProductCode],
      [ItemMaintenanceEnum.MFRName]:
        itemDetails[0][ItemMaintenanceEnum.MFRName],
      [ItemMaintenanceEnum.MFRUrl]: itemDetails[0][ItemMaintenanceEnum.MFRUrl],
    };
    if (
      bidPriceDetailsData.BidPriceDetails &&
      bidPriceDetailsData.BidPriceDetails.length
    ) {
      const { ItemId, BidId } = bidPriceDetailsData.BidPriceDetails[0];
      initialValues = {
        ...initialValues,
        [UpdateBidPriceDetailsEnum.BidId]: BidId,
        [UpdateBidPriceDetailsEnum.ItemId]: ItemId,
        [BidPriceEnum.PrimaryPrice]:
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.PrimaryPrice],
        [BidPriceEnum.BeginDT]: moment(
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.BeginDT]
        ).format(DATE_FORMAT_FOR_UI),
        [UpdateBidPriceDetailsEnum.BidPriceEndDate]: moment(
          bidPriceDetailsData.BidPriceDetails[0][
            UpdateBidPriceDetailsEnum.BidPriceEndDate
          ]
        ).format(DATE_FORMAT_FOR_UI),
        [BidPriceEnum.Unit]:
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.Unit],
        [BidPriceEnum.QtyPerUnit]:
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.QtyPerUnit],
        [BidPriceEnum.SecondaryUnit]:
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.SecondaryUnit],
        [BidPriceEnum.VendorId]:
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.VendorId],
        [BidPriceEnum.VendorItem]:
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.VendorItem],
        [BidPriceEnum.ContractItem]:
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.ContractItem],
        [BidPriceEnum.CurrentBrand]:
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.CurrentBrand],
        [BidPriceEnum.UPC]:
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.UPC],
        [BidPriceEnum.ServingsPerUnit]:
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.ServingsPerUnit],
        [BidPriceEnum.CostPerServing]: +calculateCostPerServing(
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.PrimaryPrice],
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.ServingsPerUnit]
        ),
        [BidPriceEnum.SecondaryUnitWeight]:
          bidPriceDetailsData.BidPriceDetails[0][
            BidPriceEnum.SecondaryUnitWeight
          ],
        [BidPriceEnum.SecondaryUnitMeasure]:
          bidPriceDetailsData.BidPriceDetails[0][
            BidPriceEnum.SecondaryUnitMeasure
          ],
        [BidPriceEnum.GTINNumber]:
          bidPriceDetailsData.BidPriceDetails[0][BidPriceEnum.GTINNumber],
      };
    }
  }
  return initialValues;
};

export const normalizeInput = (value, fieldName) => {
  if (!value) {
    return value;
  }

  switch (fieldName) {
    case BidPriceEnum.PrimaryPrice:
    case UpdateBidPriceDetailsEnum.Price:
      return value.match(/\d{0,3}(\.\d{0,4})?/)[0];
    case UpdateBidPriceDetailsEnum.ToBracket:
      return value.match(/\d{0,7}(\.\d{0,4})?/)[0];
    case BidPriceEnum.QtyPerUnit:
    case UpdateBidPriceDetailsEnum.From:
      return value.match(/\d{0,5}/)[0];

    case BidPriceEnum.ServingsPerUnit:
      return value.match(/\d{0,5}/)[0];

    case BidPriceEnum.SecondaryUnitWeight:
      return value.match(/\d{0,4}(\.\d{0,2})?/)[0];

    default:
      return value;
  }
};

export const NewItemHeaderRowButtons = [
  { title: 'Details', value: TabItemMaintenanceEnum.Details },
  { title: 'Pricing', value: TabItemMaintenanceEnum.BidPrice },
];

export const EditItemHeaderRowButtons = [
  { title: 'Details', value: TabItemMaintenanceEnum.Details },
  { title: 'Pricing', value: TabItemMaintenanceEnum.BidPrice },
  { title: 'FIFO', value: TabItemMaintenanceEnum.FIFO },
  {
    title: 'Transaction Details',
    value: TabItemMaintenanceEnum.TransactionDetails,
  },
];

export const makeBidItem = bidItem => {
  if (!bidItem) {
    return {};
  }
  bidItem[BidPriceEnum.BeginDT] = moment(bidItem[BidPriceEnum.BeginDT]);
  bidItem[UpdateBidPriceDetailsEnum.BidPriceEndDate] = moment(
    bidItem[UpdateBidPriceDetailsEnum.BidPriceEndDate]
  );
  bidItem[BidPriceEnum.PrimaryPrice] = (+bidItem[
    BidPriceEnum.PrimaryPrice
  ]).toFixed(4);
  bidItem[BidPriceEnum.SecondaryUnitWeight] = (+bidItem[
    BidPriceEnum.SecondaryUnitWeight
  ]).toFixed(2);

  return bidItem;
};

const SECONDARY_UNIT_MEASURE = {
  OZ: 'OZ',
  LB: 'LB',
};

export const getGramConversion = (
  secondaryUnitWeight,
  secondaryUnitMeasure
) => {
  //gram conversion calculation provided by backend team
  const DBL_OUNCE_FACTOR = 28.349523125;
  const DBL_POUND_FACTOR = 453.59237;
  let secondaryUnitWeightGrams = '0.00';

  if (!secondaryUnitWeight || !secondaryUnitMeasure) {
    return secondaryUnitWeightGrams;
  }

  if (+secondaryUnitWeight > 0) {
    if (secondaryUnitMeasure === SECONDARY_UNIT_MEASURE.OZ) {
      secondaryUnitWeightGrams = (
        +secondaryUnitWeight * DBL_OUNCE_FACTOR
      ).toFixed(2);
    } else if (secondaryUnitMeasure === SECONDARY_UNIT_MEASURE.LB) {
      secondaryUnitWeightGrams = (
        +secondaryUnitWeight * DBL_POUND_FACTOR
      ).toFixed(2);
    } else {
      secondaryUnitWeightGrams = (+secondaryUnitWeight).toFixed(2);
    }
  }

  return secondaryUnitWeightGrams;
};

export const validateTransactionDetailsForm = values => {
  const errors = {};

  if (!values[TransactionDetailsEnum.BeginDT]) {
    errors[TransactionDetailsEnum.BeginDT] = 'Please select Begin Date';
  }
  if (!values[TransactionDetailsEnum.EndDT]) {
    errors[TransactionDetailsEnum.EndDT] = 'Please select End Date';
  }
  return errors;
};

export const validateFifoForm = values => {
  const errors = {};
  if (!values[FifoEnum.ShowAll]) {
    if (!values[FifoEnum.BeginDT]) {
      errors[FifoEnum.BeginDT] = 'Please select Begin Date';
    }
    if (!values[FifoEnum.EndDT]) {
      errors[FifoEnum.EndDT] = 'Please select End Date';
    }
  }
  return errors;
};

export const isQtyPerUnitChanged = (
  bidPriceDetailsData,
  originalBidPriceData,
  selectedBidRowIndex
) => {
  //for new item, initially no bid prices exist,
  if (!originalBidPriceData || !originalBidPriceData.length) {
    return false;
  }
  if (
    bidPriceDetailsData &&
    bidPriceDetailsData.BidPriceDetails &&
    bidPriceDetailsData.BidPriceDetails.length &&
    originalBidPriceData &&
    originalBidPriceData.length
  ) {
    if (
      originalBidPriceData[selectedBidRowIndex] &&
      bidPriceDetailsData.BidPriceDetails[selectedBidRowIndex]
    ) {
      return (
        originalBidPriceData[selectedBidRowIndex][BidPriceEnum.BidId] ===
          bidPriceDetailsData.BidPriceDetails[selectedBidRowIndex][
            BidPriceEnum.BidId
          ] &&
        +originalBidPriceData[selectedBidRowIndex][BidPriceEnum.QtyPerUnit] !==
          +bidPriceDetailsData.BidPriceDetails[selectedBidRowIndex][
            BidPriceEnum.QtyPerUnit
          ]
      );
    }
  }
  return false;
};

export const getWareHouseWarningBooleanValue = warehouseWarning => {
  return (
    warehouseWarning !== DropDownEnum.NullValue &&
    warehouseWarning !== DropDownEnum.EmptyString
  );
};

export const getLookupForGTINNumberAndVendor = bidPriceDetails => {
  //lookupForGTINNumberAndVendor is storage for all distributors and git number with corresponding max date {vendorId: GTINNumber}
  let lookupForGTINNumberAndVendor = {};
  if (!bidPriceDetails || !bidPriceDetails.length) {
    return lookupForGTINNumberAndVendor;
  }
  const groupedByVendor = _.groupBy(bidPriceDetails, BidPriceEnum.VendorId);
  _.forEach(groupedByVendor, (groupedByVendorsBidPrices, vendorId) => {
    let maxDate = moment('01/01/1980');
    _.forEach(groupedByVendorsBidPrices, bidPriceRow => {
      if (
        moment(bidPriceRow[UpdateBidPriceDetailsEnum.BidPriceEndDate]).isAfter(
          maxDate
        )
      ) {
        lookupForGTINNumberAndVendor[`${vendorId}`] =
          bidPriceRow[BidPriceEnum.GTINNumber];
        maxDate = bidPriceRow[UpdateBidPriceDetailsEnum.BidPriceEndDate];
      }
    }); //end of groupedByVendorsBidPrices forEach
  }); //end of groupedByVendor forEach
  return lookupForGTINNumberAndVendor;
};

export const getGTINNumber = (BidPriceDetails, gridBidItem) => {
  const lookupForGTINNumberAndVendor = getLookupForGTINNumberAndVendor(
    BidPriceDetails
  );
  return lookupForGTINNumberAndVendor[
    BidPriceDetails[gridBidItem.selectedIndex][BidPriceEnum.VendorId]
  ];
};
export const bracketTypeOptions = [
  { text: 'None', key: 0, value: BracketTypeEnum.None },
  { text: 'Dollars', key: 1, value: BracketTypeEnum.Dollars },
  { text: 'Weight', key: 2, value: BracketTypeEnum.Weight },
  { text: 'Quantity', key: 3, value: BracketTypeEnum.Quantity },
];

export const updateBracketPricing = (dispatch, bracketPricingDetails) => {
  if (bracketPricingDetails && bracketPricingDetails.length > 0) {
    const bracketPricingDetailsClone = _.map(
      bracketPricingDetails,
      bidPriceItem => {
        bidPriceItem.Price = (+bidPriceItem.Price).toFixed(4);
        return bidPriceItem;
      }
    );
    dispatch(
      change(
        ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
        UpdateBidPriceDetailsEnum.BracketPricingDetails,
        bracketPricingDetailsClone
      )
    );
  } else {
    dispatch(
      change(
        ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
        UpdateBidPriceDetailsEnum.BracketPricingDetails,
        [
          {
            FromBracket: 0,
            ToBracket: '',
            PerUnitValue: '0.0000',
            Price: '0.0000',
            toError: false,
            priceError: false,
          },
          {
            FromBracket: '',
            ToBracket: null,
            PerUnitValue: '0.0000',
            Price: '0.0000',
            toError: false,
            priceError: false,
          },
        ]
      )
    );
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/helpers/index.js